"use client";

import { linksMobile } from "@/constants/navigation";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, Search, MessageSquare, Users, Crown, ShoppingBag } from "lucide-react";

interface Props {
  username: string;
}

const Bottombar = ({ username }: Props) => {
  const pathname = usePathname();

  const getIcon = (title: string, isActive: boolean) => {
    const props = { 
      size: 24,
      className: `transition-colors ${isActive ? 'text-primary' : 'text-muted-foreground'}`
    };

    switch (title) {
      case "Home":
        return <Home {...props} />;
      case "Search":
        return <Search {...props} />;
      case "Chatbot":
        return <MessageSquare {...props} />;
      case "Communities":
        return <Users {...props} />;
      case "Membership":
        return <Crown {...props} />;
      case "Marketplace":
        return <ShoppingBag {...props} />;
      default:
        return null;
    }
  };

  return (
    <div className="max-sm:flex sm:hidden fixed bottom-0 px-4 pb-6 pt-4 left-0 right-0 border-t border-t-gray-700 backdrop-blur bg-black/80 z-50">
      <ul className="flex items-center justify-between w-full">
        {linksMobile?.map((link) => {
          const isSamePath = link.href === pathname;

          return (
            <li key={link.title}>
              <Link
                href={link.href}
                className="flex flex-col items-center space-y-1"
              >
                {getIcon(link.title, isSamePath)}
                <span className={`text-[10px] ${
                  isSamePath 
                    ? "text-primary" 
                    : "text-muted-foreground"
                }`}>
                  {link.title}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Bottombar;